import { useEffect, useState } from "react";
import { Inbox, Flame, CalendarCheck, Trophy } from "lucide-react";
import { api } from "@/lib/api";

const CARDS = [
  { key: "new", label: "New leads", icon: Inbox, tone: "text-indigo-600 dark:text-indigo-400" },
  { key: "hot", label: "Hot leads", icon: Flame, tone: "text-orange-600 dark:text-orange-400" },
  { key: "visits_scheduled", label: "Visits scheduled", icon: CalendarCheck, tone: "text-violet-600 dark:text-violet-400" },
  { key: "won_this_month", label: "Won this month", icon: Trophy, tone: "text-emerald-600 dark:text-emerald-400" },
];

export const StatCards = ({ refreshKey }) => {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/leads/stats").then(({ data }) => setStats(data)).catch(() => setStats({})); }, [refreshKey]);
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="dashboard-stats">
      {CARDS.map(({ key, label, icon: Icon, tone }) => (
        <div key={key} className="rounded-2xl border bg-card p-4 shadow-soft" data-testid={`stat-card-${key}`}>
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium text-muted-foreground">{label}</p>
            <Icon className={`h-4 w-4 ${tone}`} />
          </div>
          {stats === null ? <div className="mt-3 h-8 w-12 animate-pulse rounded-md bg-muted" />
            : <p className="mt-2 text-3xl font-bold tracking-tight text-foreground" data-testid={`stat-value-${key}`}>{stats[key] ?? 0}</p>}
        </div>
      ))}
    </div>
  );
};
